import styled from 'styled-components';

export const ChartOperatorTopPageWrapper = styled.div`
  font-size: 0.875rem;
  width: 106.25rem;
  height: 30rem;
  background-color: white;
  border-radius: 0.625rem;
  box-shadow: 0.188rem 0.188rem 0.313rem rgba(0, 0, 0, 0.25);
  margin-top: 1rem;
  padding: 1.5rem 0rem 0rem 1rem;
  display: flex;
`;
export const LoadingOperatorTopPageWrapper = styled.div`
  width: 106.25rem;
  height: 30rem;
  background-color: white;
  border-radius: 0.625rem;
  background: rgb(255, 255, 255, 0.7);
  position: absolute;
  margin-top: -1.5rem;
  margin-left: -1rem;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const FilterChartWrapper = styled.div`
  width: 21.875rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;
export const PrepaidUsageOperator = styled.div`
  position: absolute;
  margin-top: -1.25rem;
  margin-left: 0rem;
  color: #868686;
  font-size: 0.75rem;
`;
export const WrapperChartOperator = styled.div`
  /* width: 100rem;
  height: 30rem;
  background-color: red; */
`;
